"use client";

import { useMemo } from "react";
import { getQuizState } from "../utils/utils";

/**
 * Reads quiz results from the persisted quizState in sessionStorage.
 */
export function useQuizResult() {
  return useMemo(() => {
    if (typeof window === "undefined") return null;

    try {
      const state = getQuizState();
      return state.results ?? null;
    } catch {
      console.error("Failed to get quiz result from sessionStorage");
    }

    return null;
  }, []);
}
